
import { Component, Vue, Watch } from 'vue-property-decorator';
import SiteModule from '@/store/site';

import { EventBus } from '@/lib/EventBus';

/*import * as Sentry from "@sentry/browser";
import { Integrations } from "@sentry/tracing";

Sentry.init({
    Vue: Vue,
    dsn: 'https://1ffd8ba8285f4aa7b88f1f0873f2e222@sentry.corp.code-pilots.ru/7',
    autoSessionTracking: true,
    integrations: [
        new Integrations.BrowserTracing(),
    ],

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});*/

interface Styles {
    root: string,
}

@Component({})
export default class App extends Vue {
    $style!: Styles;

    @Watch('isGlobalError')
    onIsGlobalErrorChange() {
        if (!this.isGlobalError) {
            return;
        }

        // location.reload(); // TODO::
    }

    get isGlobalError() {
        return SiteModule.isGlobalError;
    }

    listenKeyUp(e: KeyboardEvent) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            EventBus.$emit('pressEnter');
        }

        if (e.key === 'Esc' || e.keyCode === 27) {
            EventBus.$emit('pressEsc');
        }
    }

    mounted() {
        document.addEventListener('keyup', this.listenKeyUp);
    }

    unmounted() {
        document.removeEventListener('keyup', this.listenKeyUp);
    }
}
